import React from "react";
import { Div, Text, Row, Col, Button, Image } from "atomize";

import CustomContainer from "../common/CustomContainer";
import WebsiteContainer from "../common/WebsiteContainer";
import AnimateLink from "../common/AnimateLink";
import PrimaryButton from "../common/PrimaryButton";

const HomeStatsSection = content => {
  return (
    <Div className="home-stats-section">
      <WebsiteContainer>
        <CustomContainer>
          <Div>
            <Text tag="h2" className="home-stats-title">
              {content.content.title}
            </Text>
          </Div>
          <Div className="stats-action-btn">
            <PrimaryButton
              className="primary-btn"
              bg="primary"
              hoverBg="#FFCB6F"
              textColor="black"
              textTransform="none"
              border="none"
              h="3.5rem"
              onClick={() =>
                (window.location.href = content.content.actionBtn.link)
              }
            >
              {content.content.actionBtn.text}
            </PrimaryButton>
          </Div>
          <Div className="stats-list">
            <Div className="stats-item first">
              <Div className="stats-info">{content.content.creators.title}</Div>
              <Div className="stats-help-text">
                {content.content.creators.subTitle}
              </Div>
            </Div>
            <Div className="stats-item second">
              <Div className="stats-info">{content.content.photos.title}</Div>
              <Div className="stats-help-text">
                {content.content.photos.subTitle}
              </Div>
            </Div>
            <Div className="stats-item third">
              <Div className="stats-info">
                {content.content.perCreator.title}
              </Div>
              <Div className="stats-help-text">
                {content.content.perCreator.subTitle}
              </Div>
            </Div>
          </Div>
        </CustomContainer>
      </WebsiteContainer>
    </Div>
  );
};

export default HomeStatsSection;
